import {API} from "aws-amplify";
import {apiCallParameters} from "src/constants/ServiceProvidersApiConstants.tsx";
import {commonApiCallParameters, FALSE} from "src/constants/ApplicationCommonConstants";
import {refreshMidway} from "src/components/authentication/MidwayTokenRetriever";

export const serviceProvidersAuditData = async (requestType: string, userLogin: string, payload: string) => {
    let response;
    const credentials = await refreshMidway();
    try {
        response = await API.post(apiCallParameters.SERVICE_PROVIDERS_API_NAME, commonApiCallParameters.EXECUTE_REQUEST, {
            body: {
                'RequestType': requestType,
                'EncryptedPayloadRequired': FALSE,
                'Tool': apiCallParameters.SERVICE_PROVIDERS_LAMBDA,
                'UserLogin': userLogin,
                'Payload': payload,
                'Token': credentials.token,
                'ClientId': location.host
            },
            headers: {'Content-Type': commonApiCallParameters.CONTENT_TYPE}
        });
        return response;
    }
    catch (error) {
        throw error;
    }
}